/* @flow @format */

import type { Reducer } from 'redux';

import { type ActionType, createAction } from '../utils';
import type { FailurePayload } from '../types';

export type Config = {
  +mute: boolean,
};

// Actions

const FETCH_USERCONFIG_BEGIN: 'proc/config/FETCH_USERCONFIG_BEGIN' = 'proc/config/FETCH_USERCONFIG_BEGIN';
const FETCH_USERCONFIG_SUCCESS: 'proc/config/FETCH_USERCONFIG_SUCCESS' = 'proc/config/FETCH_USERCONFIG_SUCCESS';
const FETCH_USERCONFIG_FAILURE: 'proc/config/FETCH_USERCONFIG_FAILURE' = 'proc/config/FETCH_USERCONFIG_FAILURE';
const UPLOAD_USERCONFIG_BEGIN: 'proc/config/UPLOAD_USERCONFIG_BEGIN' = 'proc/config/UPLOAD_USERCONFIG_BEGIN';
const UPLOAD_USERCONFIG_SUCCESS: 'proc/config/UPLOAD_USERCONFIG_SUCCESS' = 'proc/config/UPLOAD_USERCONFIG_SUCCESS';
const UPLOAD_USERCONFIG_FAILURE: 'proc/config/UPLOAD_USERCONFIG_FAILURE' = 'proc/config/UPLOAD_USERCONFIG_FAILURE';

const CONFIG_MUTE_SET: 'proc/config/CONFIG_MUTE_SET' = 'proc/config/CONFIG_MUTE_SET';

type FetchFailurePayload = FailurePayload<void>;
type UploadFailurePayload = FailurePayload<void>;

export const fetchUserConfigBegin = createAction<typeof FETCH_USERCONFIG_BEGIN, void>(FETCH_USERCONFIG_BEGIN);
export const fetchUserConfigSuccess = createAction<typeof FETCH_USERCONFIG_SUCCESS, any>(FETCH_USERCONFIG_SUCCESS);
export const fetchUserConfigFailure = createAction<typeof FETCH_USERCONFIG_FAILURE, FetchFailurePayload>(
  FETCH_USERCONFIG_FAILURE
);
export const uploadUserConfigBegin = createAction<typeof UPLOAD_USERCONFIG_BEGIN, void>(UPLOAD_USERCONFIG_BEGIN);
export const uploadUserConfigSuccess = createAction<typeof UPLOAD_USERCONFIG_SUCCESS, void>(UPLOAD_USERCONFIG_SUCCESS);
export const uploadUserConfigFailure = createAction<typeof UPLOAD_USERCONFIG_FAILURE, UploadFailurePayload>(
  UPLOAD_USERCONFIG_FAILURE
);

export const setConfigMute = createAction<typeof CONFIG_MUTE_SET, boolean>(CONFIG_MUTE_SET);

export type ConfigActionType =
  | ActionType<typeof fetchUserConfigBegin>
  | ActionType<typeof fetchUserConfigSuccess>
  | ActionType<typeof fetchUserConfigFailure>
  | ActionType<typeof uploadUserConfigBegin>
  | ActionType<typeof uploadUserConfigSuccess>
  | ActionType<typeof uploadUserConfigFailure>
  | ActionType<typeof setConfigMute>;

// Reducer

const reducer: Reducer<Config, ConfigActionType> = (state = { mute: false }, action: ConfigActionType) => {
  switch (action.type) {
    case CONFIG_MUTE_SET:
      return { ...state, mute: action.payload };
    case FETCH_USERCONFIG_SUCCESS: {
      const { mute = false } = action.payload;
      return { ...state, mute };
    }
    case FETCH_USERCONFIG_BEGIN:
    case FETCH_USERCONFIG_FAILURE:
    case UPLOAD_USERCONFIG_BEGIN:
    case UPLOAD_USERCONFIG_SUCCESS:
    case UPLOAD_USERCONFIG_FAILURE:
      return state;
    default:
      /*::(action.type: empty)*/
      return state;
  }
};

export default reducer;
